import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { useNotificationsStore } from '@/stores/notificationsStore'
import { NotificationToastItem } from './NotificationToastItem'
import { safeInternalNotificationUrl } from './notificationPresentation'

export function NotificationToastStack() {
  const navigate = useNavigate()
  const toasts = useNotificationsStore((state) => state.toasts)
  const dismiss = useNotificationsStore((state) => state.dismissToast)
  const markRead = useNotificationsStore((state) => state.markRead)
  const timersRef = useRef(new Map<string, number>())

  useEffect(() => {
    const timers = timersRef.current
    const visibleIds = new Set(toasts.map((toast) => toast.id))

    for (const [id, timerId] of timers) {
      if (!visibleIds.has(id)) {
        window.clearTimeout(timerId)
        timers.delete(id)
      }
    }

    for (const toast of toasts) {
      if (timers.has(toast.id)) continue
      timers.set(
        toast.id,
        window.setTimeout(() => {
          timers.delete(toast.id)
          dismiss(toast.id)
        }, 8000),
      )
    }
  }, [dismiss, toasts])

  useEffect(
    () => () => {
      for (const timerId of timersRef.current.values()) {
        window.clearTimeout(timerId)
      }
      timersRef.current.clear()
    },
    [],
  )

  return (
    <Box
      sx={{
        position: 'fixed',
        // Позиции в sx не умножаются на theme.spacing: число здесь — пиксели.
        // Отступ задан явно, иначе тосты прилипают к углу экрана.
        // На телефоне стек растянут между отступами, тост сужается до него
        left: { xs: '16px', sm: 'auto' },
        right: { xs: '16px', sm: '24px' },
        bottom: { xs: '16px', sm: '24px' },
        zIndex: 'snackbar',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      {toasts.map((notification) => (
        <NotificationToastItem
          key={notification.id}
          notification={notification}
          onClose={() => dismiss(notification.id)}
          onOpen={() => {
            const target = safeInternalNotificationUrl(notification.url)
            void markRead(notification.id).catch(() => {})
            dismiss(notification.id)
            if (target) {
              navigate(target)
            }
          }}
        />
      ))}
    </Box>
  )
}
